import { initializeReactWidget } from "~/common/widgets/frontend";
import { VideoView } from "./components/VideoView";
import { VideoEdit } from "./components/VideoEdit";
import config from "./widget.json";

// the widget class name is used to identify elements to attach our React component to
// the php widget file uses this same value when rendering the widget container
const widgetClassName = config.name;
initializeReactWidget(widgetClassName, VideoView, VideoEdit);
